import { Component } from '@angular/core';
import { NewsFeedItemContentBase } from '../news-feed-item-content-base';
import { MediaBankStorageType } from '@fi-shared/media-bank/media-bank-storage-type';
import { FileType } from '@fi-shared/types';

@Component({
    selector: 'fi-news-feed-item-content-media-bank',
    templateUrl: './news-feed-item-content-media-bank.component.html',
    styleUrls: ['./news-feed-item-content-media-bank.component.scss'],
    standalone: false,
})
export class NewsFeedItemContentMediaBankComponent extends NewsFeedItemContentBase {
    Limit = 6;

    protected LoadMore() {
        this.Limit = this.newsItem.MediaBankFileReferences.length;
    }

    protected isVimeoStorage(storageType: MediaBankStorageType) {
        return this.mediaStorageService.isVimeoStorage(storageType);
    }

    protected isImageNotClickable(fileType: FileType) {
        return false;
        // customer, who use private object storage, can't open pdfs in browser
        //return fileType === FileType.Pdf && !this.customerDataService.canOpenPdfs();
    }
}
